import { useEffect, useRef } from 'react';
import { Message } from 'semantic-ui-react';

import { useErrorsContext } from './useErrorsContext';
import styled from '@emotion/styled';

type Props = {
  className?: string;
};

export const ValidationErrors = ({ className }: Props) => {
  const { generalErrors } = useErrorsContext();
  const messageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (generalErrors.length > 0 && messageRef.current) {
      messageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [generalErrors]);

  if (!generalErrors.length) return null;

  return (
    <S.Message
      className={className}
      error
      content={
        <div ref={messageRef}>
          <h4>An error occurred while processing your request</h4>
          <ul>
            {generalErrors.map((error, index) => (
              <li key={index}>{error.message}</li>
            ))}
          </ul>
        </div>
      }
    />
  );
};

const S = {
  Message: styled(Message)`
    &.ui.message {
      display: flex !important;
    }
  `,
};
